// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { StatementAction } from '@app/core';

@Component({
  selector: 'app-selectable-action-table',
  templateUrl: './selectable-action-table.component.html',
  styleUrls: ['./selectable-action-table.component.scss']
})
export class SelectableActionTableComponent implements OnInit {
  readonly _selected: StatementAction[] = [];
  currentPageNumber = 0;
  filteredList: any;

  @Input() selected: StatementAction[] = [];
  @Input() actions: StatementAction[] | undefined = undefined;
  @Output() selectActions = new EventEmitter<StatementAction[]>();

  constructor() {}

  ngOnInit() {}

  rowIdentity(row: StatementAction) {
    return row.id;
  }

  onSelect({ selected }: { [selected: string]: StatementAction[] }) {
    this.clearSelected();
    this._selected.push(...selected);
    this.selectActions.emit(this._selected);
  }

  private clearSelected() {
    this._selected.splice(0, this._selected.length);
  }

  filterList(text: string = '') {
    const searchValue = text.toLowerCase();
    this.filteredList = this.actions
      ? this.actions.filter(
          item =>
            JSON.stringify(item)
              .toLowerCase()
              .includes(searchValue) || !searchValue
        )
      : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/selectable-action-table/selectable-action-table.component.ts